import {
  Flex,
  SimpleGrid,
  Center,
  Spacer,
  Text,
  Skeleton,
  SkeletonText,
  useColorModeValue,
  useColorMode,
} from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import React, { useEffect, useState } from "react";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";

function Tables() {
  const { colorMode } = useColorMode();
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(apiUrl + "/data/stats", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setStats(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  }, []);

  const renderStatsCard = (periodData, title) => (
    <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
      <CardHeader p="6px 0px 22px 0px">
        <Center>
          <Skeleton isLoaded={!loading}>
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              {title} #{periodData.period}
              <Center>
                <Text fontSize="xs" color={textColor} fontWeight="bold">
                  ({periodData.periodDate})
                </Text>
              </Center>
            </Text>
          </Skeleton>
        </Center>
      </CardHeader>
      <CardBody>
        <SkeletonText isLoaded={!loading}>
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            Statystyki ogólne
          </Text>
          <Text fontSize="m" color={textColor}>
            Pożary: {periodData.globalStats.p_count}
          </Text>
          <Text fontSize="m" color={textColor}>
            Miejscowe zagrożenia: {periodData.globalStats.mz_count}
          </Text>
          <Text fontSize="m" color={textColor}>
            Alarmy Fałszywe: {periodData.globalStats.af_count}
          </Text>
          <Text fontSize="m" color={textColor}>
            Inne: {periodData.globalStats.o_count}
          </Text>
          <Spacer height={4} />
          <Text fontSize="m" color={textColor}>
            Jednostka Ratowniczo-Gaśnicza nr 1:{" "}
            {periodData.globalStats.jrg1_count}
          </Text>
          <Text fontSize="m" color={textColor}>
            Jednostka Ratowniczo-Gaśnicza nr 2:{" "}
            {periodData.globalStats.jrg2_count}
          </Text>
          <Text fontSize="m" color={textColor}>
            Szkoła Podoficerska: {periodData.globalStats.sp_count}
          </Text>
          <Spacer height={4} />
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            Poszczególne wozy
          </Text>
          <Spacer height={2} />
          <Text fontSize="xm" color={textColor} fontWeight="bold">
            Jednostka Ratowniczo-Gaśnicza nr 1
          </Text>
          {periodData.vehiclesStats.map((row, index, arr) => {
                return (
                  <>
                    {row.jednostka == "Jednostka Ratowniczo-Gaśnicza nr 1" && (
                      <Text fontSize="m" color={textColor}>
                        {row.woz} - {row.wyjazdy}
                      </Text>
                    )}
                  </>
                );
              })}
                        <Spacer height={2} />
          <Text fontSize="xm" color={textColor} fontWeight="bold">
            Jednostka Ratowniczo-Gaśnicza nr 2
          </Text>
          {periodData.vehiclesStats.map((row, index, arr) => {
                return (
                  <>
                    {row.jednostka == "Jednostka Ratowniczo-Gaśnicza nr 2" && (
                      <Text fontSize="m" color={textColor}>
                        {row.woz} - {row.wyjazdy}
                      </Text>
                    )}
                  </>
                );
              })}
                        <Spacer height={2} />
          <Text fontSize="xm" color={textColor} fontWeight="bold">
            Szkoła Podoficerska
          </Text>
          {periodData.vehiclesStats.map((row, index, arr) => {
                return (
                  <>
                    {row.jednostka == "Szkoła Podoficerska" && (
                      <Text fontSize="m" color={textColor}>
                        {row.woz} - {row.wyjazdy}
                      </Text>
                    )}
                  </>
                );
              })}
        </SkeletonText>
      </CardBody>
    </Card>
  );

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 3 }} spacing="24px" mb="20px">
        {stats.currentPeriod
          ? renderStatsCard(stats.currentPeriod, "Obecny okres rozliczeniowy")
          : <Skeleton height="400px" />}
        {stats.m1Period
          ? renderStatsCard(stats.m1Period, "Ostatni okres rozliczeniowy")
          : <Skeleton height="400px" />}
        {stats.m2Period
          ? renderStatsCard(stats.m2Period, "Przedostatni okres rozliczeniowy")
          : <Skeleton height="400px" />}
      </SimpleGrid>
    </Flex>
  );
}

export default Tables;
